import SinglePageMapView from './SinglePageMapView'


export default SinglePageMapView
